import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ResumeForm from './profile';
import ExperienceDetailsForm from './experience';
import ProjectsForm from './projects';
import AchievementsForm from './acheive';
import CertificationsForm from './certifications';
import LanguagesForm from './language';
import InterestsForm from './interest';
import AvailabilityForm from './availability';
import SalaryExpectationsForm from './salary';
import SelfIdentificationForm from './selfidentification';
import LegalAuthorizationForm from './legalauthorize';
import WorkPreferencesForm from './workpreference';
import EducationForm from './education';
import reportWebVitals from './reportWebVitals';
import VerticalTabs from './home';
import { ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <VerticalTabs/>
    <ToastContainer></ToastContainer>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
